class SaveState {
    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
}

export default SaveState;